import React, {Component} from 'react';

import axios from 'axios';
import auth0Client from '../../Auth';
import {ToastContainer, ToastStore} from 'react-toasts';
import {   withRouter } from "react-router-dom";
//import Claims from '../Claims/Claims';
import {SERVER_URL}  from '../../Constants';

import LostItemFunctions from '../../LostItem/LostItemFunctions';
import DatePicker from "react-datepicker";
//import MaterialTable,{MTableToolbar, MTableHeader} from 'material-table';
import MaterialTable from '@material-table/core';
import { ExportCsv } from '@material-table/exporters';
import { forwardRef } from 'react';

import AddBox from '@material-ui/icons/AddBox';
import ArrowDownward from '@material-ui/icons/ArrowDownward';
import Check from '@material-ui/icons/Check';
import ChevronLeft from '@material-ui/icons/ChevronLeft';
import ChevronRight from '@material-ui/icons/ChevronRight';
import Clear from '@material-ui/icons/Clear';
import DeleteOutline from '@material-ui/icons/DeleteOutline';
import Edit from '@material-ui/icons/Edit';
import FilterList from '@material-ui/icons/FilterList';
import FirstPage from '@material-ui/icons/FirstPage';
import LastPage from '@material-ui/icons/LastPage';
import Remove from '@material-ui/icons/Remove';
import SaveAlt from '@material-ui/icons/SaveAlt';
import Search from '@material-ui/icons/Search';
import ViewColumn from '@material-ui/icons/ViewColumn';
import Modal from 'react-responsive-modal';




export const CheckBox = props => {
    return (
      <li>
       <input key={props.id} onChange={props.handleCheckChieldElement} type="checkbox" checked={props.isChecked} value={props.value} /> {props.value}
      </li>
    )
}

const tableIcons = {
    Add: forwardRef((props, ref) => <AddBox {...props} ref={ref} />),
    Check: forwardRef((props, ref) => <Check {...props} ref={ref} />),
    Clear: forwardRef((props, ref) => <Clear {...props} ref={ref} />),
    Delete: forwardRef((props, ref) => <DeleteOutline {...props} ref={ref} />),
    DetailPanel: forwardRef((props, ref) => <ChevronRight {...props} ref={ref} />),
    Edit: forwardRef((props, ref) => <Edit {...props} ref={ref} />),
    Export: forwardRef((props, ref) => <SaveAlt {...props} ref={ref} />),
    Filter: forwardRef((props, ref) => <FilterList {...props} ref={ref} />),
    FirstPage: forwardRef((props, ref) => <FirstPage {...props} ref={ref} />),
    LastPage: forwardRef((props, ref) => <LastPage {...props} ref={ref} />),
    NextPage: forwardRef((props, ref) => <ChevronRight {...props} ref={ref} />),
    PreviousPage: forwardRef((props, ref) => <ChevronLeft {...props} ref={ref} />),
    ResetSearch: forwardRef((props, ref) => <Clear {...props} ref={ref} />),
    Search: forwardRef((props, ref) => <Search {...props} ref={ref} />),
    SortArrow: forwardRef((props, ref) => <ArrowDownward {...props} ref={ref} />),
    ThirdStateCheck: forwardRef((props, ref) => <Remove {...props} ref={ref} />),
    ViewColumn: forwardRef((props, ref) => <ViewColumn {...props} ref={ref} />)
  };

const moment = require('moment');





  



  const startOfMonth = moment().clone().startOf('day').toDate();
  const endOfMonth = moment().clone().endOf('day').toDate();



  class ShippingReportAdvanced extends Component {
    
    constructor(props) {
      super(props);
      this.tableRef = React.createRef();
        this.state = { 
            shippingRecords: [],
            startDate: startOfMonth,
            endDate: endOfMonth,
            refreshButtonText:'Run',
            isPrinting:false,
            displayFilterModal:false,
            monthCd:"0",
        
            totalServiceFee:0.00,
            filteredNames :[],
            enableFilters:false,
           
           // columns: matrialColumns,
        }
        this._input = null;
        
    }
    async componentDidMount() {


        // console.log("Component did load. Auth : " + auth0Client.getIdToken());
         
         this.loadShippingReport();
      
     
       }
       
       loadShippingReport=()=>{
        
        
   

        try {
            axios.put(`${SERVER_URL}/Reports/ShippingTransactionReportAdvanced`,
            {
              startDate:this.state.startDate,
              endDate:this.state.endDate,
            },
            {
               headers: { 
                 'Authorization': `Bearer ${auth0Client.getIdToken()}`,
                 'venueId' : auth0Client.getActiveVenuedId()
               }
              
              }).then((res)=>{
               
               if (res.status===undefined || res.status !==200) {
                 //place your reentry code
                 console.log("Error" + res.status);
                 ToastStore.error("An error occured. Please try again");
                }
                let totalReturned = 0;
               
                let shippingRecords = [];
               // console.log(res.data);

                if (res.data && res.data.shippingResults){
                    shippingRecords = res.data.shippingResults;
                  if (shippingRecords){
                      totalReturned= shippingRecords.length;
                   };
                  
                }
                
               this.setState({
                  numReturned : totalReturned,
                  shippingRecords : shippingRecords,
                  refreshButtonText:'Run',
                  displayFilterModal:false,
                  totalServiceFee:res.data.totalServiceFee,
                  totalAmount:res.data.totalAmount,
                });
  
  
              },
              (error)=>{
                if (error.response && error.response.status === 401){
                  ToastStore.error("Not Authorized, Please log out and log in again: " + error.message);
                }else {
                  ToastStore.error('An error occured:' + error.message);
                }
                
              }
              );
              
          }catch(e){
              //console.log(e);
              ToastStore.error('An error occured:' + e.message);
              this.setState({refreshButtonText:'Run'})
          }


       }


       

  
    renderToast=()=>{
        return <div>
            
            <ToastContainer position={ToastContainer.POSITION.TOP_RIGHT} lightBackground store={ToastStore}/>
        </div>
      }

      print=()=>{
       
            // STEP 1: Create a new window, a div, and append it to the window. The div 
            // *MUST** be created by the window it is to be appended to (Edge only)
          

            /*this.externalWindow = window.open('', '', 'width=600,height=400,left=200,top=250');
            var ss = document.createElement("link"); ss.type = "text/css"; ss.rel = "stylesheet"; ss.href = "https://bootswatch.com/4/lux/bootstrap.min.css"; 
            this.externalWindow.document.getElementsByTagName("head")[0].appendChild(ss);


            this.containerEl = this.externalWindow.document.createElement('div');
            this.externalWindow.document.body.appendChild(this._input);
        */
                this.setState({
                    isPrinting:true,
                },()=>{
                    if (this.state.isPrinting) {
                       this.printWindow();
                    } 

                });
                
      }
      printWindow=()=>{
        window.print();
        this.setState({
            isPrinting:false,
        })
      }
     
      renderTitle=()=>{
          return(
          
                  <div>
                    <h3>Shipping Report</h3>
                    <h6>Shipping Transactions and updates Between : {LostItemFunctions.formatDate(this.state.startDate) + ' to ' + LostItemFunctions.formatDate(this.state.endDate)}</h6>
                    <h6>    </h6>
                    <hr/>
                </div> 
              )
      }
     exportCSV=(cols, datas, filename)=>{
       
     }


      rendermaterialGrid=()=>{
        
        return (
            <MaterialTable
                icons={tableIcons}
                tableRef={this.tableRef}
                onSearchChange={() => {
                  let totalRecords = 0;
                  let totalServiceFee=0;
                  //let totalAmount=0;
                  console.log(this.tableRef); 
                  if (this.tableRef && this.tableRef.current.dataManager){
                    totalRecords=this.tableRef.current.dataManager.searchedData.length; 
                    for(var i=0; i<this.tableRef.current.dataManager.searchedData.length; i++){
                      if (!isNaN(Number.parseFloat(this.tableRef.current.dataManager.searchedData[i].serviceFee))){
                        totalServiceFee+=Number.parseFloat(this.tableRef.current.dataManager.searchedData[i].serviceFee);
                        }
                      //if (!isNaN(Number.parseFloat(this.tableRef.current.dataManager.searchedData[i].amount))){
                      //  totalAmount+=Number.parseFloat(this.tableRef.current.dataManager.searchedData[i].amount);
                      //  }
                }
                  }
                  
                  this.setState({
                    numReturned:totalRecords,
                    totalServiceFee:totalServiceFee
                  })
                  //console.log(tableRef.current.DataManager.filteredData.length);
                }}
                
                columns={ [
                                      
                   
                    { title: 'id', field: 'id', hidden:true , id:1, grouping:false},
                    { title: 'Recipient', field: 'to', hidden:false , id:2},
                    { title: 'Address', field: 'shipTo', hidden:false , id:3},

                    { title: 'Status', render: (value, renderType) => this.customRender(value, renderType,this.statusFormatter,  'status'), field: 'status', hidden:false , id:4, grouping:true},
                    { title: 'Date Created', field: 'createdAt', render: rowData=>LostItemFunctions.formatDateTime(rowData.createdAt), type: 'datetime' , hidden:false, id:5  },
                    { title: 'Updated', field: 'updatedAt', render: rowData=>LostItemFunctions.formatDateTime(rowData.updatedAt), type: 'datetime' , hidden:false, id:6  },
                    { title: 'Paid Amount', field: 'amount',render: rowData=>LostItemFunctions.formatMoney(rowData.amount), hidden:false , id:7},
                    { title: 'Service Fee', field: 'shippingFee',render: rowData=>LostItemFunctions.formatMoney(rowData.shippingFee), hidden:false , id:8},
                    { title: 'Currency', field: 'currency', hidden:false , id:8},
                    { title: 'refunded', render: (value, renderType) => this.customRender(value, renderType,this.paidFormatter,  'refunded'), field: 'refunded', hidden:false , id:9, grouping:true},
                    
                    { title: 'Insurance Amount', field: 'insuranceAmount',render: rowData=>LostItemFunctions.formatMoney(rowData.insuranceAmount), hidden:false , id:10},

                  ]

                  }
                defaultExpanded={true}
                components={{
                    SummaryRow: ()=>{
                      return (
                        <tr>
                            <td><b>Total Items:</b><p className='text-info'> <strong>{this.state.numReturned}</strong></p></td>
                            <td><b>Total Service Fee:</b><p className='text-info'> <strong>{LostItemFunctions.formatMoney(this.state.totalServiceFee)}</strong></p></td>
                            <td><b>Total Amount:</b><p className='text-info'> <strong>{LostItemFunctions.formatMoney(this.state.totalAmount)}</strong></p></td>
                            
                        </tr>// <MTableSummaryRow {...props} />
                    )}

                    

                }}
              data={this.state.shippingRecords}        
              options={{
                grouping: true,
                search: true,
                paging: false,
                header:true,
                showTitle:false,
                toolbar:true,
                defaultExpanded: true,
                columnsButton: true,
                filtering:this.state.enableFilters,
                headerStyle: {
                    backgroundColor: '#D3D3D3',
                    color: '#000',
                  },
                  exportMenu: [{
                    label: 'Export CSV (No Group Support)',
                    exportFunc: (cols, datas) =>  ExportCsv(cols, datas, 'myCsvShipments')
                  }]
                
              }}

              actions={[
                {
                  icon:()=> <img style={{margin:10, width:24, height:24}} src='../images/gear.jpg' alt='Change the report settings'  onClick={()=>this.setState({displayFilterModal:true})} />,
                  tooltip:'Show Filters',
                  isFreeAction:true  //display at top, otherwise would show up on the row
                },
                {
                  icon:()=><img style={{margin:10, width:24, height:24}} src='../images/print_icon.jpg' alt='Print the current report'   onClick={this.print}/>,
                  tooltip:'Print',
                  isFreeAction:true  //display at top, otherwise would show up on the row
                }
              ]}
            />
          )


    }
     customRender=(value, renderType, renderFunc, field, ...args)=>{
       //console.log('Render status code:' + value[field]);
        if (renderType === 'row') {
            return renderFunc(value[field],...args);
        }
        if (renderType === 'group') {
            return renderFunc(value, ...args);
        }
    }
    formaParcelAge=(dateVal)=>{
        try{
         // console.log(dateVal);
            if (dateVal){
              var today = new Date();
              var foundDate = (dateVal) ?   Date.parse(dateVal): Date () ;
              var res = Math.abs(today - foundDate) / 1000;
              var days = Math.floor(res / 86400);
              return days;
            }
          }catch(e){
            console.log(e);
            return -1;
            
          }
         
       
      }
    
      paidFormatter=(refunded)=>{
        if (refunded){
          return (<h6 className="text-danger">Yes</h6>);
        }else{
          return (<h6 className="text-primary">No</h6>);
        }
      }

      statusFormatter=(statusCd)=>{
        return (<h6 className="text-info">{statusCd}</h6>);
      
      
      }
   

renderButtons=()=>{
    return(
        <div className='row'>
             <div className='col-10 text-right'></div>
            <div className='col-2 text-right'>
                <img style={{margin:10, width:24, height:24}} src='../images/gear.jpg' alt='Change the report settings'  onClick={()=>this.setState({displayFilterModal:true})} />
                    
                <img style={{margin:10, width:24, height:24}} src='../images/print_icon.jpg' alt='Print the current report'   onClick={this.print}/>
            </div>
        </div>
    )
}

setDateMacro=(event)=>{
    const target = event.target;
    const value = target.type === 'checkbox' ? target.checked : target.value;
    //const name = target.name;

    let startDate = moment().clone().startOf('month').toDate();
    let endDate = moment().clone().endOf('month').toDate();

    if (value==='0'){
        // Today
        startDate = moment().clone().startOf('day').toDate();
        endDate = moment().clone().endOf('day').toDate();

    }else if (value==='1'){
        // This week
        startDate = moment().clone().startOf('week').toDate();
        endDate = moment().clone().endOf('week').toDate();

    }
    else if (value==='2'){
        // Last Three Months 
        startDate = moment().clone().startOf('month').subtract(2, 'months').toDate();
        endDate = moment().clone().endOf('month').toDate();

    }else if(value==='3'){
        // last year
        startDate = moment().clone().subtract(1, 'year').startOf('year').toDate()
        endDate = moment().clone().subtract(1, 'year').endOf('year').toDate()
    }else if (value==='4'){
        // this month
        startDate = moment().clone().startOf('month').toDate();
        endDate = moment().clone().endOf('month').toDate();
    }else if (value==='5'){
        // this year
        startDate = moment().clone().startOf('year').toDate();
        endDate = moment().clone().endOf('year').toDate();

    }
    this.setState({
        startDate: startDate,
        endDate: endDate,
        monthCd: value,
    })
}
handleAllChecked = (event) => {
    let columns = this.state.columns
    columns.forEach(col => col.hidden = !event.target.checked) 
    this.setState({columns: columns})
  }
handleCheckChieldElement = (event) => {
    let columns = this.state.columns;
    console.log(event.target.value)
    columns.forEach(col => {
       if (col.title === event.target.value){
            col.hidden =  !event.target.checked
     }
    })
    this.setState({columns: columns})
  }
  handleInputChange=(event) =>{
    const target = event.target;
    const value = target.type === 'checkbox' ? target.checked : target.value;
    const name = target.name;

    this.setState({
      [name]: value
    });
  }
    renderDateRange=()=>{
        return(

            <Modal open={this.state.displayFilterModal} onClose={()=>{this.setState({displayFilterModal:false})}} center>
      
           
         


            <div className='row'>
                <div className='col text-info'><h5>Report Settings</h5></div> 
                <hr/><br/><br/>
            </div>
            <div className='row'>      
                <div className='col'>
                <b>Shipping Activity Range:</b>
                </div>
            </div>
            
            <div className='row'>      
                <div className='col'>
                    <select className='custom-select'  value={this.state.monthCd} name='monthCd' onChange={this.setDateMacro}>
                        <option value='0'>Today</option>
                        <option value='1'>This Week</option>
                        <option value='2'>Last 3-Months</option>
                        <option value='3'>Last Year</option>
                        <option value='4'>This Month</option>
                        <option value='5'>This Year</option>

                    </select>
                </div>
            </div>
            <br/>
           <div className='row'>      
                <div className='col'>
                    <label style={{width:100}} htmlFor="exampleInputEmail1" className='text-primary'>From:</label>
                           
                             <DatePicker
                              className="form-control"
                                onChange={date => this.setState({ startDate:date })}
                                name="foundDate"
                                selected={this.state.startDate}
                              /> 
            </div>
              
                <div className='col'>
                    <label style={{width:100}} htmlFor="foundBy" className='text-primary'> To:</label>
                    <DatePicker
                                    className="form-control"
                                    onChange={date => this.setState({ endDate:date })}
                                        name="foundDate"
                                        selected={this.state.endDate}
                                    /> 
                            
                </div>
            </div>
            <br/> <hr/>
           
           
         
          

            <br/>
            <div className='row'>      
                <div className='col text-center'>
         
                <div ><button className="btn btn-success btn-sm" id="optArchive" onClick={this.loadShippingReport} >{this.state.refreshButtonText}</button></div>
                </div>
            </div>
            

          </Modal> 
        )
    }
    LandscapeOrientation = () => (
        <style type="text/css">
          {"@media print{@page {size: landscape}}"}
        </style>
      );

    render(){

        return(

            <div className="text-center" ref={c => (this._input = c)}> 
           
            {this.renderTitle()}
            {
            //!this.state.isPrinting && this.renderButtons()
            }
              {this.renderToast()}
              {this.rendermaterialGrid()}
              { this.renderDateRange()}
              {this.LandscapeOrientation()}
              <br/><br/><br/><br/><br/>
            </div>

        )



    }
}


export default withRouter(ShippingReportAdvanced);